import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const ScrollingText = ({
  text,
  textColor = "#000",
  backgroundColor = "#fff",
  speed = 20, // Speed in seconds
}) => {
  const { t, i18n } = useTranslation();
  const animationName = i18n.dir() === "ltr" ? "scrollLeft" : "scrollRight";
  console.log("direction", i18n.dir());

  return (
    <div style={{ ...styles.container, backgroundColor }}>
      <div
        style={{
          ...styles.text,
          color: textColor,
          animationName,
          animationDuration: `${speed}s`,
        }}
      >
        {text}
      </div>
    </div>
  );
};

const styles = {
  container: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    width: "100%",
    padding: "10px 0",
  },
  text: {
    display: "inline-block",
    // paddingRight: "100%", // Ensures smoother looping
    fontSize: "1.2em",
    animationTimingFunction: "linear",
    animationIterationCount: "infinite",
  },
};

// CSS animations
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(
  `
  @keyframes scrollLeft {
    0% { transform: translateX(100%); }
    100% { transform: translateX(-100%); }
  }
`,
  styleSheet.cssRules.length
);

styleSheet.insertRule(
  `
  @keyframes scrollRight {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }
`,
  styleSheet.cssRules.length
);

export default ScrollingText;
